
(() => {
  function initStickyCart() {
    document.querySelectorAll("[data-sticky-product]").forEach((bar) => {
      if (bar.dataset.initialized === "true") return;

      const productForm = document.querySelector(
        ".shopify-product-form:has(#addToCartButton)"
      );

      const originalButton = productForm?.querySelector("#addToCartButton");
      const sizeElement = bar.querySelector(".aqua-sticky-cart__size");
      const priceElement = bar.querySelector(".aqua-sticky-cart__price");
      const stickyButton = bar.querySelector(".aqua-sticky-cart__button");

      if (!originalButton || !productForm || !stickyButton) return;

      bar.dataset.initialized = "true";

      let isAddingToCart = false;

      const productArea =
        productForm.closest("section") || productForm.parentElement;

      const picker = productArea.querySelector(
        ".product-variant-picker-block"
      );



      function getSelectedSize() {
        const scopes = [picker, productArea, document];

        for (const scope of scopes) {
          if (!scope) continue;

          const checked = scope.querySelector(
            'input[data-single-option-selector]:checked'
          );

          if (checked) return checked.value;

          const select = scope.querySelector(
            'select[data-single-option-selector]'
          );

          if (select && select.value) {
            return select.value;
          }
        }

        return "";
      }

      function updateBar() {
        const size = getSelectedSize();

        if (sizeElement) {
          sizeElement.textContent = size
            ? "Taglia " + size
            : "Seleziona taglia";
        }

        const price = productArea.querySelector("[data-product-price]");

        if (price && priceElement) {
          priceElement.textContent = price.textContent.trim();
        }

        stickyButton.disabled =
          originalButton.disabled || isAddingToCart;

        stickyButton.setAttribute(
          "aria-disabled",
          String(stickyButton.disabled)
        );
      }

      function updateVisibility() {
        if (window.innerWidth > 1025) {
          bar.classList.remove("is-visible");
          bar.hidden = true;
          return;
        }

        const rect = productArea.getBoundingClientRect();
        const hasPassedProductArea = rect.bottom < 700;

        bar.hidden = !hasPassedProductArea;
        bar.classList.toggle("is-visible", hasPassedProductArea);
      }

        function showCartError(message) {
        const notice = document.getElementById("AquaCartError");

        if (!notice) return false;

        notice.textContent = message;
        notice.hidden = false;

        if (window.Spruce?.store) {
            const drawer = window.Spruce.store("drawer");
            drawer.cartOpener = stickyButton;
            drawer.cartDrawerOpen = true;
            return true;
        }

        return false;
        }

      // AGGIUNTA AL CARRELLO DALLA STICKY BAR
    stickyButton.addEventListener("click", async () => {
        if (isAddingToCart) return;

        if (originalButton.disabled) {
          picker?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          return;
        }

        const variantId = productForm.querySelector('[name="id"]')?.value;

        if (!variantId) {
          picker?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          return;
        }

        isAddingToCart = true;
        updateBar();

        try {
          const response = await fetch(
            (window.Shopify?.routes?.root || "/") + "cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1
                  }
                ]
              })
            }
          );

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));

            throw new Error(
              errorData.description ||
              errorData.message ||
              "Impossibile aggiungere il prodotto al carrello."
            );
          }

            const errorNotice = document.getElementById("AquaCartError");

            if (errorNotice) {
            errorNotice.textContent = "";
            errorNotice.hidden = true;
            }

          document.body.dispatchEvent(
            new CustomEvent("baseline:modalcart:afteradditem")
          );

        } catch (error) {
          console.error("Sticky cart:", error);

          const message =
            error.message ||
            "Impossibile aggiungere il prodotto al carrello.";

          if (!showCartError(message)) {
            alert(message);
          }

        } finally {
          isAddingToCart = false;
          updateBar();
        }
      });

      // AGGIORNAMENTO TAGLIA E PREZZO
      document.addEventListener("change", (event) => {
        if (!event.target.matches("[data-single-option-selector]")) {
          return;
        }

        requestAnimationFrame(updateBar);
        setTimeout(updateBar, 100);
      });

      const observer = new MutationObserver(updateBar);

      observer.observe(originalButton, {
        attributes: true,
        attributeFilter: ["disabled", "class"]
      });

      updateBar();
      updateVisibility();

      window.addEventListener("scroll", updateVisibility, {
        passive: true
      });

      window.addEventListener("resize", updateVisibility);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyCart);
  } else {
    initStickyCart();
  }

  document.addEventListener("shopify:section:load", initStickyCart);
})();
